/**
 * A pele dos controles de escrever — uma só, em `Campo`, `Seletor`,
 * `CampoDeBusca`, na data e nas caixas de `pergunta.tsx`.
 *
 * Mora num `.ts` à parte, e não em `comuns.jsx`, porque `pergunta.tsx` também a
 * veste e TypeScript não importa `.jsx` sem tipo. Cada campo com a medida
 * escrita à mão era o que deixava três alturas e três fundos na mesma linha de
 * formulário.
 *
 * O foco é BORDA terra com halo de 3px, e não o anel dos botões: dentro de um
 * campo o anel afastado 2px parecia um segundo campo em volta do primeiro. O
 * halo vai por `shadow-` e não por `ring-`: o anel único do `index.css` zera o
 * `--tw-ring-shadow` de todo botão, e o gatilho do seletor é um botão.
 */

/** 36 no computador, 44 no dedo; raio 10; borda de controle (3:1). */
export const PELE_DE_CAMPO =
  "h-padrao max-[759px]:h-toque w-full rounded-controle border border-borda-controle bg-card px-3 text-corpo text-foreground placeholder:text-tinta-fraca hover:border-tinta-fraca";

/** Foco do próprio elemento (input, textarea, gatilho do seletor). */
export const FOCO_DE_CAMPO =
  "focus-visible:border-terra focus-visible:ring-0 focus-visible:shadow-[0_0_0_3px_color-mix(in_oklab,var(--color-terra)_16%,transparent)]";

/** Foco do contêiner (a busca: lupa, campo e ✕ na mesma borda). */
export const FOCO_DENTRO =
  "focus-within:border-terra focus-within:shadow-[0_0_0_3px_color-mix(in_oklab,var(--color-terra)_16%,transparent)]";

/** Erro: borda destrutiva e o halo dela, lidos do `aria-invalid`. */
export const ERRO_DE_CAMPO =
  "aria-invalid:border-destructive aria-invalid:ring-0 aria-invalid:shadow-[0_0_0_3px_color-mix(in_oklab,var(--color-destructive)_12%,transparent)]";

/* Desabilitado legível: fundo apagado e borda tracejada, a letra em
   tinta-fraca (4,5:1). A opacidade de 50% do registro apagava a letra junto. */
export const CAMPO_DESLIGADO =
  "disabled:cursor-not-allowed disabled:border-dashed disabled:bg-muted disabled:text-tinta-fraca disabled:opacity-100";

export const CAMPO = `${PELE_DE_CAMPO} ${FOCO_DE_CAMPO} ${ERRO_DE_CAMPO} ${CAMPO_DESLIGADO}`;
